import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "instruction-list scrollable-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inlineList = _resolveComponent("inlineList")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_checklist = _resolveComponent("checklist")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_modalWrapper = _resolveComponent("modalWrapper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.instructions && _ctx.instructions.length > 0)
      ? (_openBlock(), _createBlock(_component_ion_row, {
          key: 0,
          class: "full-width instruction-modal-btn"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_item, {
              button: "",
              detail: "",
              class: "full-width",
              "data-cy": "button-instruction-modal",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modalOpen = !_ctx.modalOpen))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, { class: "ion-padding-start" }, {
                  default: _withCtx(() => [
                    _cache[2] || (_cache[2] = _createTextVNode(" Special Instructions ")),
                    _createVNode(_component_inlineList, {
                      items: _ctx.instructions?.filter((i) => i.selected),
                      keyName: "name"
                    }, null, 8, ["items"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_modalWrapper, {
      title: "Special Instructions",
      open: _ctx.modalOpen,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modalOpen = false)),
      onDismiss: _ctx.modalOpen,
      "data-cy": "instructions-modal"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_checklist, {
            items: _ctx.instructions,
            keyName: "name",
            dense: "",
            hideSplitOpts: "",
            hideQuantity: "",
            class: "ion-padding list-buffer"
          }, null, 8, ["items"])
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_ion_button, {
          color: "primary",
          expand: "full",
          size: "large",
          class: "force-bottom interstate-bold full-width ma-0",
          onClick: _ctx.add
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createTextVNode(" Add Instruction ")
          ])),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["open", "onDismiss"])
  ], 64))
}